// extracted by mini-css-extract-plugin
export default {"row":"FlagRow_row__VV8vg","packagesCell":"FlagRow_packagesCell__5b88E"};